const S3_BUCKET_NAME = process.env.REACT_APP_AWS_S3_BUCKET_NAME;
const S3_URL = `https://${S3_BUCKET_NAME}.s3-accelerate.amazonaws.com/`;

export default S3_URL;
